import React, { useState } from 'react';

const LANGUAGE_LIST = [
  "한국어", "영어", "프랑스어", "이탈리아어", "독일어", "스페인어(ES)",
  "불가리아어", "체코어", "덴마크어", "네덜란드어", "핀란드어", "그리스어", "헝가리어",
  "인도네시아어", "일본어", "노르웨이어", "폴란드어", "포르투갈어(BR)", "포르투갈어(PT)",
  "루마니아어", "러시아어", "중국어(간체)", "스페인어(LA)", "스웨덴어", "태국어",
  "중국어(번체)", "터키어", "우크라이나어", "베트남어"
];

// props: supportedLanguages, onChange (or value, onChange 둘 다 지원)
export default function GameEditLanguageSupport({
  supportedLanguages,
  value, // 둘 다 지원: value 우선, 없으면 supportedLanguages
  onChange
}) {
  const [open, setOpen] = useState(false);

  // value: [{name, ui, audio, subtitle}]
  const checkedArr = value || supportedLanguages || [];
  // 모든 언어 목록을 기본 false로 만들어줌 (표시용)
  const langState = LANGUAGE_LIST.map(name => {
    const found = checkedArr.find(v => v.name === name);
    return found || { name, ui: false, audio: false, subtitle: false };
  });

  // 실제로 보여줄 행 개수 결정
  const visibleLangs = open ? langState : langState.slice(0, 5);

  // 체크 시 동작: 체크한 항목만 저장
  const handleCheck = (idx, type) => {
    const curr = langState[idx];
    const updated = { ...curr, [type]: !curr[type] };
    let newArr;
    if (!updated.ui && !updated.audio && !updated.subtitle) {
      // 모두 체크 해제 시 value에서 해당 언어 삭제
      newArr = checkedArr.filter(l => l.name !== curr.name);
    } else if (checkedArr.find(l => l.name === curr.name)) {
      // 이미 있는 항목이면 항목만 갱신
      newArr = checkedArr.map(l =>
        l.name === curr.name ? updated : l
      );
    } else {
      // 새로 추가
      newArr = [...checkedArr, updated];
    }
    // 순서 유지 (표현을 위해 정렬)
    newArr = LANGUAGE_LIST
      .map(name => newArr.find(l => l.name === name))
      .filter(Boolean);
    onChange(newArr);
  };

  return (
    <div className="bg-neutral-800 p-4 rounded">
      <h4 className="text-md font-semibold mb-2">지원 언어</h4>
      <table className="w-full text-sm text-gray-300 border-collapse table-fixed">
        <thead>
          <tr className="border-b border-gray-600 text-left">
            <th className="py-2 w-1/4 text-left">언어</th>
            <th className="py-2 w-1/4 text-center">인터페이스</th>
            <th className="py-2 w-1/4 text-center">오디오</th>
            <th className="py-2 w-1/4 text-center">자막</th>
          </tr>
        </thead>
        <tbody>
          {visibleLangs.map((lang) => {
            const idx = langState.findIndex(l => l.name === lang.name);
            return (
              <tr key={lang.name} className="border-b border-gray-700">
                <td className="py-1 w-1/4 text-xs text-left text-white">{lang.name}</td>
                <td className="py-1 text-center">
                  <input
                    type="checkbox"
                    checked={lang.ui}
                    onChange={() => handleCheck(idx, 'ui')}
                    className="w-5 h-5 accent-purple-400"
                  />
                </td>
                <td className="py-1 text-center">
                  <input
                    type="checkbox"
                    checked={lang.audio}
                    onChange={() => handleCheck(idx, 'audio')}
                    className="w-5 h-5 accent-purple-400"
                  />
                </td>
                <td className="py-1 text-center">
                  <input
                    type="checkbox"
                    checked={lang.subtitle}
                    onChange={() => handleCheck(idx, 'subtitle')}
                    className="w-5 h-5 accent-purple-400"
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {langState.length > 5 && (
        <div className="mt-3 flex justify-center">
          <button
            type="button"
            onClick={() => setOpen(open => !open)}
            className="px-5 py-1 rounded bg-gray-700 hover:bg-gray-600 text-sm"
          >
            {open ? "접기" : "열기"}
          </button>
        </div>
      )}
    </div>
  );
}